module.exports = __webpack_public_path__ + "static/media/stepper_blue.3d330ca9.png";